<template>
  <div>
    <LayoutPageHeader 
      :title="`Blog Posts from ${year}`" 
      background-image="https://cdn-media.geekcafe.com/a0d4d17b-ec8f-4f28-9169-97e3e5bb4d37/person-looking-at-phone-and-at-macbook-pro-1181244_1920x400.jpg" 
    />

    <main class="archive">
      <div class="container">
        <div class="row">
          <div class="col-lg-8">
            <div v-if="posts.length" class="row">
              <div v-for="post in posts" :key="post._path" class="col-md-6 mb-4">
                <BlogCard :post="post" />
              </div>
            </div>
            <div v-else class="text-center py-5">
              <p>No posts found for this year.</p>
            </div>
          </div>
          <div class="col-lg-4">
            <BlogSidebar />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup>

const route = useRoute();
const year = route.params.year;

const { data: posts } = await useAsyncData(`posts-${year}`, async () => {
  const allPosts = await $fetch('/api/posts');
  return allPosts.filter(post => post.date && post.date.startsWith(year));
});

definePageMeta({
  layout: 'default',
});

useHead({
  title: `Blog Posts from ${year}`,
});
</script>

<style scoped>
.archive {
  padding: 4rem 0;
}
</style>
